import { render, staticRenderFns } from "./organisations.vue?vue&type=template&id=351583b6&"
import script from "./organisations.vue?vue&type=script&lang=js&"
export * from "./organisations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports